import { RoutingMap } from '@app/entities';
import { AboutUsIcon, AnalyticsIcon, AppStoreIcon, EditIcon, NoteIcon } from '@assets';
import { MPMenu } from '@components';
import { Layout } from 'antd';
import UserProfile from '../UserProfile';
import Styles from './Styles.module.scss';
import useHeader from './useHeader';
import { useWindowSize } from 'react-use';
import { getLocationParts } from '@common';
import type { MenuProps } from 'antd';
type ItemType = NonNullable<MenuProps['items']>[number];

export default function Header() {
    const { menu, onClick } = useHeader();
    const { width } = useWindowSize();
    const { maindomain } = getLocationParts();

    function renderMenuItems() {
        return menu.map(key => {
            const itemList = width < 768 ? MenuItemsWithoutLabel : MenuItems;
            return itemList.find(item => item?.key === key) as MenuItemType;
        });
    }

    const logo = width <= 500 ? '/mobile-logo.svg' : '/logo.svg';

    return (
        <>
            <Layout.Header className={Styles.HeaderContainer}>
                <div className={Styles.MenuSection}>
                    <a
                        href={`${window.location.protocol}//${maindomain}`}
                        className={Styles.LogoContainer}
                    >
                        <img
                            src={logo}
                            alt="logo"
                            className={Styles.logo}
                        />
                    </a>

                    <MPMenu
                        items={renderMenuItems()}
                        onClick={onClick}
                        className={Styles.NavMenu}
                        theme="dark"
                        defaultSelectedKeys={[window.location.pathname]}
                        selectedKeys={[window.location.pathname]}
                    />
                </div>

                <UserProfile />
                {/* <ThemeSwitch /> */}
            </Layout.Header>
        </>
    );
}

const MenuItems: MenuItemType[] = [
    {
        key: RoutingMap.Home,
        label: 'Apps',
        icon: <MenuIcon name="Home" />,
        title: 'Home',
    },
    {
        key: RoutingMap.NewProject,
        label: 'New Project',
        icon: <MenuIcon name="NewProject" />,
        title: 'New Project',
    },
    {
        key: RoutingMap.Cli,
        label: 'CLI',
        icon: <MenuIcon name="Cli" />,
        title: 'CLI',
    },
    {
        key: RoutingMap.Analytcis,
        label: 'Analytics',
        icon: <MenuIcon name="Analytcis" />,
        title: 'Analytics',
        className: Styles.Analytics,
    },
    {
        key: RoutingMap.About,
        label: 'About',
        icon: <MenuIcon name="About" />,
        title: 'About',
    },
];
const MenuItemsWithoutLabel = MenuItems.map(({ label, ...rest }) => rest);

const MenuIconMap = {
    Home: <AppStoreIcon />,
    NewProject: <EditIcon />,
    Cli: <NoteIcon />,
    Analytcis: <AnalyticsIcon />,
    About: <AboutUsIcon />,
};

function MenuIcon({ name }: { name: keyof typeof MenuIconMap }) {
    return <div className={Styles.MenuIcon}>{MenuIconMap[name]}</div>;
}
type MenuItemType = ItemType & { key: string; label?: string };
